import script from "./VexPolar.vue?vue&type=script&setup=true&lang=ts"
export * from "./VexPolar.vue?vue&type=script&setup=true&lang=ts"

import "./VexPolar.vue?vue&type=style&index=0&id=bcee1a52&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcee1a52"]])

export default __exports__